import * as React from 'react';
import { Box } from '@mui/material';

interface StatusDotsProps {
  dots: Array<number>;
  getBgColor: (dotIndex: number) => string;
}

export const StatusDots: React.FC<StatusDotsProps> = (props) => {
  const { dots, getBgColor } = props;

  return (
    <Box display="flex" justifyContent="center">
      {dots.map((dotIndex) => (
        <Box
          key={`step-dot-${dotIndex}`}
          margin={1}
          sx={{
            width: 12,
            height: 12,
            borderRadius: 12,
            boxShadow: '0px 0px 4px rgb(0 0 0 / 12%)',
            minWidth: 'unset',
            padding: 0,
            backgroundColor: getBgColor(dotIndex),
          }}
        />
      ))}
    </Box>
  );
};
